import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hrHRTranslations from './hr_HR.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      hr_HR: {
        name: 'Hrvatski',
        translation: hrHRTranslations,
      },
    },
    lng: 'hr_HR',
    fallbackLng: 'hr_HR',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
